import { supabase } from "@/integrations/supabase/client";

interface CreateChatParams {
  userId: string;
  firstMessage: string;
  roomId?: string | null;
  searchEnabled?: boolean;
  contentReferenceIds?: string[];
}

export async function createChatFromStudyInput({
  userId,
  firstMessage,
  roomId = null,
  searchEnabled = false,
  contentReferenceIds,
}: CreateChatParams) {
  // 1. Create a new content item (chat)
  const { data: contentRow, error: contentError } = await supabase
    .from("content")
    .insert({
      user_id: userId,
      room_id: roomId,
      title: firstMessage.slice(0, 60) || "New Chat",
      type: "chat",
      visibility: "private",
    })
    .select("*")
    .single();

  if (contentError) throw contentError;

  // 2. Build metadata for the first message
  const metadata: Record<string, any> = {};
  if (searchEnabled) metadata.searchEnabled = true;
  if (contentReferenceIds && contentReferenceIds.length > 0) {
    metadata.contentReferenceIds = contentReferenceIds;
  }

  // 3. Insert the first user message with metadata
  const { error: messageError } = await supabase
    .from("chat_messages")
    .insert({
      content_id: contentRow.id,
      user_id: userId,
      role: "user",
      message: firstMessage,
      metadata: Object.keys(metadata).length > 0 ? metadata : null,
    });

  if (messageError) throw messageError;

  return contentRow;
}
